<div id="executive-council" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">Executive Council</h2>
    <p class="inner-lead mt-3">
      The Executive Council is the principal executive body of the College constituted as per the directions of the
      affiliating university. It exercises all powers and performs all duties as specified in the Act, Statutes and
      Ordinances.
    </p>

    <hr class="divider">

    <h4 class="section-subtitle">Approval of Election Board</h4>

    <div class="pdf-block">
      <pdf-viewer src="/assets/pdf/admin/Approval-of-election-board.pdf" [render-text]="true" [original-size]="false"
        style="width:100%; height:680px; display:block;">
      </pdf-viewer>
    </div>

    <div class="mt-3">
      <a href="/assets/pdf/admin/Approval-of-election-board.pdf" target="_blank" class="pdf-download-btn">
        <i class="fa fa-download"></i> Download Executive Council Document
      </a>
    </div>

  </div>
</div>